import React from "react";
import PropTypes from "prop-types";
import ModalManager from "./ModalManager";
import closeIcon from "assets/IconExitModal.svg?url";
import FocusLock, { FreeFocusInside } from "react-focus-lock";
import clsx from "clsx";

const sizeClassMap = {
	small: "StandardModal--small",
	medium: "StandardModal--medium",
	xlarge: "StandardModal--xlarge",
};

const StandardModal = ({ open, keepOpen, close, size, title, children, actions, contentClassName, header, bodyClass }) => {
	const handleEsc = (ev) => {
		if (open && ev.key === "Escape") {
			ev.stopPropagation();
			close();
		}
	};

	if (!open) return null;

	const rootClass = clsx("StandardModal", sizeClassMap[size], bodyClass);
	const contentClass = clsx("StandardModal_content", contentClassName);
	return (
		<ModalManager open={open} onBackdropClick={keepOpen ? () => {} : close}>
			<div className={rootClass} tabIndex={-1} onKeyDown={handleEsc} onClick={(ev) => ev.stopPropagation()}>
				<FocusLock className="StandardModal_focusLock">
					<button
						onClick={keepOpen ? () => {} : close}
						className={keepOpen ? "StandardModal_closeIcon--disabled" : "StandardModal_closeIcon"}
					>
						<img src={closeIcon} alt="" />
					</button>
					{title && (
						<h2 className="StandardModal_title" title={title}>
							{title}
						</h2>
					)}
					{header}
					<div className="focus-holder" tabIndex={-1} data-autofocus />
					<FreeFocusInside className={contentClass}>{children}</FreeFocusInside>
					<div className="StandardModal_actions">{actions}</div>
				</FocusLock>
			</div>
		</ModalManager>
	);
};

export default StandardModal;

StandardModal.propTypes = {
	open: PropTypes.bool,
	keepOpen: PropTypes.bool,
	close: PropTypes.func.isRequired,
	size: PropTypes.oneOf(["small", "medium", "xlarge"]),
	title: PropTypes.string,
	children: PropTypes.node,
	actions: PropTypes.node,
	header: PropTypes.node,
	contentClassName: PropTypes.string,
	bodyClass: PropTypes.string,
};
